import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Input from '../../../components/input/Input';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { numberFields, validateNumberInput } from '../../../utils/formValidations';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import { formatDate } from '../../../utils/dateUtils';
import { formatAmount } from '../../../utils/formatAmount';
import useExpense from './useExpense';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteConfirm from '../../../sharedComponents/DeleteConfirm';
import Modal from 'react-modal';
import useShipDate from '../../setting/shipDate/useShipDate';

const initialValue = {
  amount:'',
  optionId:'',
  expenseDate: new Date(),
  note: '',
  shipDateId:''
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '500px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const items = [
  {
    title: 'Confirm to Delete this Record ?',
    name: '',
    type: 'text',
  },
];

const ExpenseRecord = () => {

  const IconComponent = (params) => {
    return <IconButton onClick={() => openConfirm(params.data.id)}>
            <DeleteIcon style={{ color: 'red' }}/>
          </IconButton>
  }
  const columnDefs = [
    { headerName: 'Expense Date', field: 'expenseDate', flex: 1 },
    { headerName: 'เหคุผล', field: 'option', flex: 1 },
    { headerName: 'Amount', field: 'amount', flex: 1 },
    { headerName: 'Note', field: 'note', flex: 1 },
    { headerName: 'รอบเรือ', field: 'shipDate', flex: 1 },
    {
      headerName: 'Delete',
      field: 'delete',
      cellRenderer: IconComponent,
      flex: 1
    }
  ];

  const [formData, setFormData] = useState(initialValue);
  const {error, expenseOptions, expenses, getExpenseOptions, saveExpenseRecord, getExpenseRecords, deleteExpense} = useExpense()
  const {shipDates, getShipDates} = useShipDate()
  const [rowData, setRowData] = useState([])
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [expense, setExpense] = useState('')
  const [haveShipDate, setHaveShipDate] = useState(false)

  const handleSelectChange = (name, value) => {
    setFormData(formData => ({
      ...formData,
      [name]: value
    }));
  };

  const handleDeleteRecord = async () => {
    const response = await deleteExpense(expense.id)
    if(response){
      toast.success("Delete Travel card successfully")
      closeConfirm()
    }else{
      toast.error("Something wrong.")
    }
  }

  const handleDateChange = (name, selectedDate) => {
    setFormData(prevOrder => ({
        ...prevOrder,
        [name]: selectedDate
    }));
	};

  const handleInputChange = (name, value) => {
    if (numberFields.has(name)) {
			value = validateNumberInput(value, formData[name]);
		}
    setFormData(formData => ({
      ...formData,
      [name]:value
    }))
  }

  useEffect(() => { 
    const formattedRecords = expenses.map(record => ({
    ...record, // spread the other properties of the order
    expenseDate: formatDate(record.expenseDate), // overwrite orderDate with the formatted version
    amount : formatAmount(record.amount),
    option: record.ExpenseOption ? record.ExpenseOption.option : 'N/A',
    shipDate : record.ShipDate ? formatDate(record.ShipDate.shipDate) : ""
  }));
    setRowData(formattedRecords)
  }, [expenses]);
  
  const handleSaveButton = async (e) => {
    e.preventDefault()
    if(haveShipDate && !formData.shipDateId){
      toast.error("กรุณาเลือก รอบเรือ")
    }else{
      console.log(formData)
      const response = await saveExpenseRecord(formData)
      if(response){
        toast.success("Add Expense Record Successfully!!")
      }else{
        toast.error(error)
      }
      setFormData(initialValue)
    }
  }

  const openConfirm = async (id) => {
    const expenseToDelete = expenses.find(w => w.id === id);
    console.log(expenseToDelete)
    if(expenseToDelete) {
      setExpense(expenseToDelete)
      setIsConfirmOpen(true)
    }
  };

  const closeConfirm = () =>{
    setIsConfirmOpen(false)
  }

  useEffect(() => {
    const option = expenseOptions.find(w => w.id === formData.optionId);
    if(option?.haveShipDate){
      setHaveShipDate(true)
    }else{
      setHaveShipDate(false)
    }
  },[formData.optionId])

  useEffect(() => {
		getExpenseOptions()
    getExpenseRecords()
    getShipDates()
	},[])

  return (
    <div className="ag-theme-alpine" style={{ width: '100%' }}>
      <h2>
        Expense Record
      </h2>
      <Modal
        isOpen={isConfirmOpen}
        onRequestClose={closeConfirm}
        style={customStyles}
        ariaHideApp={false}
      >
        <DeleteConfirm 
          items={items} 
          data={expense} 
          closeConfirm={closeConfirm}
          confirmFunction={handleDeleteRecord}
        />
      </Modal>
      <div className='grid grid-cols-3'>
        <div className='col-span-2'>
        <AgGridReact
          columnDefs={columnDefs}
          rowData={rowData}
          domLayout='autoHeight'
          defaultColDef={{ resizable: true }}
          frameworkComponents={{
            iconComponent: IconComponent
          }}
        />
        </div>
        <div className='col-span-1'>
          <form className='mx-5 border-gray-300 border rounded-lg'>
            <div className='bg-gray-200 px-4 py-2 rounded-t-lg border-t'>
              <h3 className='text-3xl '>Input New Data</h3>
            </div>
            <div className='p-5 mx-1'>
              <InputLabel 
                id="expenseDate-label" 
                style={{
                  fontSize:'1.1em',
                  color:'black',
                  paddingLeft:'2px'
                }}
              >
                Expense Date
              </InputLabel>
              <DatePicker 
								selected={formData?.expenseDate}
								onChange={(date) => handleDateChange("expenseDate", date)}
								dateFormat={"yyyy-MM-dd"}
								className='datepicker2 w-full mb-4'
							/>
              <InputLabel 
                id="optionId-label" 
                style={{
                  fontSize:'1.1em',
                  color:'black',
                  paddingLeft:'2px'
                }}
                size="normal"
              >
                เหตุผล
              </InputLabel>
              
              <Select
                labelId="optionId-label"
                id="optionId"
                value={formData?.optionId}
                onChange={(e) => handleSelectChange('optionId',e.target.value)}
                size="small"
                fullWidth
                defaultValue=''
              >
                {expenseOptions && expenseOptions.map((option) => (
                  <MenuItem key={option.id} value={option.id}>{option.option}</MenuItem>
                ))}
              </Select>
              {haveShipDate && <>
              <InputLabel 
                id="shipDateId-label" 
                style={{
                  fontSize:'1.1em',
                  color:'black',
                  paddingLeft:'2px'
                }}
                size="normal"
                sx={{mt : 2}}
              >
                รอบเรือ
              </InputLabel>
              
              <Select
                labelId="shipDateId-label"
                id="shipDateId"
                value={formData?.shipDateId}
                onChange={(e) => handleSelectChange('shipDateId',e.target.value)}
                size="small"
                defaultValue=''
                fullWidth
                
              >
                {shipDates && shipDates.map((shipDate) => (
                  <MenuItem key={shipDate.id} value={shipDate.id}>{formatDate(shipDate.shipDate)}</MenuItem>
                ))}
              </Select></>}
              <div className='mt-3'></div>
              <Input title={'Amount'} name={'amount'} value={formData?.amount} onChange={value => handleInputChange('amount',value)} /* customClass={'mb-4'} *//>
              <Input title={'Note'} name={'note'} value={formData?.note} onChange={value => handleInputChange('note',value)} /* customClass={'mb-4'} *//>
              <button className='w-32 btn btn-save text-lg' onClick={handleSaveButton}>Save</button>

            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ExpenseRecord